export const POLICY_URL = "https://algorithmica.com/privacy-notice/";
export const GA_ID = "G-5QZ1L0N1EK"